<template>
	<div id="contact-us">
		<div class="title">Мы здесь, чтобы помочь!</div>
		<div class="desc">Если вы хотите связаться с нами, не стесняйтесь начать чат или отправить нам сообщение по электронной почте на <a href="mailto:support@nageshenme.com">support@nageshenme.com</a>. Мы будем рады услышать вас.</div>
		<div class="date">С понедельника по пятницу</div>
		<div class="time">с 9:00 до 17:00</div>
	</div>
</template>
<script>
export default {
	name: "contact-us",
	components: {
		
	},
	data() {
		return {
			
		}
	},
	created() {
		
	},
	methods: {
		
	}
}
</script>
<style lang="less">
#contact-us {
	padding: 80px 160px;

	.title {
		font-size: 3.5rem;
		font-weight: 900;
	}

	.desc {
		padding: 14px 0;
		font-size: 24px;
		line-height: 28px;
		font-weight: 300;

		a {
			color: var(--el-color-primary);
		}
	}

	.date {
		font-size: 24px;
		font-weight: 600;
		margin-top: 20px;
	}

	.time {
		font-size: 24px;
		font-weight: 500;
		margin-top: 10px;
	}
}
</style>